/* vvd-slidecart-tier-fix.js  (v4, 18 Jun 2026)
   AMP Slide Cart: re-enable quantity + keep itoris tier pricing correct on quantity change,
   shown clearly as a sale price (original struck-through grey + discounted red bold).
   v3: only re-renders when the CART ACTUALLY CHANGES (quantity/price), so it no longer
   collapses the line-item 'more details' caret.
   v4: removes the legacy AMP "To change quantity, remove item from the cart and add again"
   tooltip/title now that the quantity field is fully editable. Safe by design: only ever
   displays values straight from /cart.js. */
(function(){
  var SC='#slidecarthq';
  function money(c){ return '$'+(c/100).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function reEnable(sc){ sc.querySelectorAll('.quantity-selector input').forEach(function(e){ e.style.setProperty('pointer-events','auto','important'); }); sc.querySelectorAll('.quantity-selector button').forEach(function(b){ b.style.setProperty('display','inline-flex','important'); }); }
  /* v4: kill the obsolete "change quantity / remove item" tooltip the app paints on the qty area */
  function killTooltip(sc){
    try{
      sc.querySelectorAll('[title]').forEach(function(e){
        if(/change quantity|remove item from the cart/i.test(e.getAttribute('title')||'')) e.removeAttribute('title');
      });
      [].slice.call(sc.querySelectorAll('*')).forEach(function(e){
        if(e.children && e.children.length) return; /* leaf nodes only */
        var t=(e.textContent||'').trim();
        if(/^to change quantity|remove item from the cart and add again/i.test(t)){
          var box=(e.closest && (e.closest('[class*=tooltip i]')||e.closest('[role=tooltip]')))||e;
          box.style.setProperty('display','none','important');
        }
      });
    }catch(e){}
  }
  function rows(sc){ var all=[].slice.call(sc.querySelectorAll('*')).filter(function(e){ return e.querySelector && e.querySelector('.quantity-selector') && e.querySelector('.price-discount-block'); }); return all.filter(function(e){ return !all.some(function(o){ return o!==e && e.contains(o); }); }); }
  function sig(j){ return (j.items||[]).map(function(it){ return it.quantity+':'+it.final_line_price+':'+it.original_line_price; }).join('|'); }
  var lastSig=null, applying=false, deb=null;
  function sync(force){
    var sc=document.querySelector(SC); if(!sc) return;
    fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){ return r.json(); }).then(function(j){
      var s=sig(j);
      if(!force && s===lastSig){ killTooltip(sc); return; }   /* cart unchanged: still clear stray tooltip */
      lastSig=s; applying=true;
      var rs=rows(sc);
      rs.forEach(function(row,i){ var it=j.items[i]; if(!it) return; var pb=row.querySelector('.price-discount-block'); if(!pb) return;
        var o=it.original_line_price, f=it.final_line_price;
        var want=(o!==f) ? ('<span class="price strike-through line vvd-was">'+money(o)+'</span> <span class="price vvd-now">'+money(f)+'</span>') : ('<span class="price">'+money(f)+'</span>');
        if(pb.innerHTML.replace(/\s+/g,' ').trim()!==want.replace(/\s+/g,' ').trim()) pb.innerHTML=want;
      });
      var sub=sc.querySelector('.slidecart-subtotal'); if(sub){ var st=money(j.total_price!=null?j.total_price:j.items_subtotal_price); if(sub.textContent.trim()!==st) sub.textContent=st; }
      reEnable(sc); killTooltip(sc);
      setTimeout(function(){ applying=false; }, 60);
    }).catch(function(){ applying=false; });
  }
  function schedule(){ if(applying) return; clearTimeout(deb); deb=setTimeout(function(){ sync(false); }, 300); }
  function attach(){
    var sc=document.querySelector(SC);
    if(sc && !sc.__vqTierWatched){ sc.__vqTierWatched=true; reEnable(sc); killTooltip(sc); sync(true);
      try{ new MutationObserver(schedule).observe(sc,{subtree:true,childList:true,characterData:true}); }catch(e){}
    }
  }
  function boot(){
    try{ var st=document.createElement('style'); st.setAttribute('data-vvd','slidecart-qty');
      st.textContent='#slidecarthq .quantity-selector input{pointer-events:auto !important;}'
        +'html body #slidecarthq .quantity-selector button{display:inline-flex !important;}'
        +'#slidecarthq .vvd-was{text-decoration:line-through !important;color:#9aa0a6 !important;font-weight:400 !important;opacity:.9;margin-right:5px;}'
        +'#slidecarthq .vvd-now{color:#e3201a !important;font-weight:700 !important;}'+'#slidecarthq .quantity-selector::before{content:none !important;display:none !important;}';
      (document.head||document.documentElement).appendChild(st);
    }catch(e){}
    attach(); setInterval(attach, 800);
  }
  if(document.readyState!=='loading'){ boot(); } else { document.addEventListener('DOMContentLoaded',boot); }
})();
